<template lang="pug">
  div
    table.table.table-bordered.table_document
      tr
        td Дата выдачи свидетельства о смерти
        td
          span(v-if='data.body.content.deliver_date') {{data.body.content.deliver_date | date}}
          span(v-if='!data.body.content.deliver_date') —
      tr
        td Вид медицинского свидетельства о смерти
        td {{formatAnswer(data.body.content.certificate_type, 3)}}
      tr
        td Медицинская организация, выдавшая свидетельство
        td {{formatAnswer(data.body.content.medical_organization, 3)}}
    h2 Информация об умершем
    table.table.table-bordered.table_document
      tr
        td Пол
        td {{formatAnswer(data.body.content.gender, 3)}}
      tr
        td Дата рождения
        td
          span(v-if='data.body.content.birth_date') {{data.body.content.birth_date | date}}
          span(v-if='!data.body.content.birth_date') —
      tr
        td Дата и время смерти
        td
          span(v-if='data.body.content.death_date_time') {{data.body.content.death_date_time | datetime}}
          span(v-if='!data.body.content.death_date_time') —
      tr
        td Место постоянного жительства (регистрации)
        td {{formatAnswer(data.body.content.residence, 2)}}
      tr
        td Местность
        td {{formatAnswer(data.body.content.territory, 3)}}
      tr
        td Место смерти
        td {{formatAnswer(data.body.content.death_place_text, 2)}}
      tr
        td Смерть наступила
        td {{formatAnswer(data.body.content.death_place, 3)}}
      tr
        td Семейное положение
        td {{formatAnswer(data.body.content.marital_status, 3)}}
      tr
        td Образование
        td {{formatAnswer(data.body.content.education_data, 3)}}
      tr
        td Занятость
        td {{formatAnswer(data.body.content.employment, 3)}}
      tr
        td Смерть произошла
        td {{formatAnswer(data.body.content.death_cause, 3)}}
      tr
        td Дата и время происшествия для смерти от внешних причин
        td
          span(v-if='data.body.content.death_date_time_text') {{data.body.content.death_date_time_text | datetime}}
          span(v-if='!data.body.content.death_date_time_text') —
      tr
        td Основание для определения причины смерти
        td {{formatAnswer(data.body.content.death_cause_evidence, 3)}}
      tr
        td Причины смерти
        td(v-if="data.body.content.death_causes_list")
          table.table.table-bordered.table_document
            tr
              td а) Болезнь или состояние, напосредственно приведшее к смерти
              td {{formatAnswer(data.body.content.death_causes_list.death_disease, 3)}}
            tr
              td Период времени
              td {{formatAnswer(data.body.content.death_causes_list.death_disease, 5)}}
            tr
              td Код МКБ10
              td {{formatAnswer(data.body.content.death_causes_list.death_disease, 6)}}
            tr
              td б) Патологическое состояние, которое привело к возникновению вышеуказанной причины
              td {{formatAnswer(data.body.content.death_causes_list.pathological_condition, 3)}}
            tr
              td Период времени
              td {{formatAnswer(data.body.content.death_causes_list.pathological_condition, 5)}}
            tr
              td Код МКБ10
              td {{formatAnswer(data.body.content.death_causes_list.pathological_condition, 6)}}
            tr
              td в) Первоначальная причина смерти
              td {{formatAnswer(data.body.content.death_causes_list.death_cause, 3)}}
            tr
              td Период времени
              td {{formatAnswer(data.body.content.death_causes_list.death_cause, 5)}}
            tr
              td Код МКБ10
              td {{formatAnswer(data.body.content.death_causes_list.death_cause, 6)}}
            tr
              td г) Внешняя причина при травмах и отравлениях
              td {{formatAnswer(data.body.content.death_causes_list.external_cause, 3)}}
            tr
              td Период времени
              td {{formatAnswer(data.body.content.death_causes_list.external_cause, 5)}}
            tr
              td Код МКБ10
              td {{formatAnswer(data.body.content.death_causes_list.external_cause, 6)}}
        td(v-if="!data.body.content.death_causes_list") —
      tr
        td Прочие важные состояния, способствовавшие смерти, но не связанные с болезнью или патологическим состоянием, приведшим к ней
        td(v-if="data.body.content.important_states_list")
          table.table.table-bordered.table_document( v-for='important_states in data.body.content.important_states_list')
            tr
              td Текстовое значение причины
              td {{formatAnswer(important_states.cause_text_value, 2)}}
            tr
              td Код МКБ10
              td {{formatAnswer(important_states.mkb_code, 2)}}
            tr
              td Код услуги
              td {{formatAnswer(important_states.service_code, 4)}}
        td(v-if="!data.body.content.important_states_list")  —
      tr
        td В случае смерти в результате ДТП
        td {{formatAnswer(data.body.content.road_accident_case, 3)}}
      tr
        td Связь смерти с беременностью
        td {{formatAnswer(data.body.content.pregnancy_death, 3)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? this.formatAnswer(fact.name, 2) : '—'
        case 4:
          return fact ? this.formatAnswer(fact.code, 2) + ' — ' + this.formatAnswer(fact.name, 2) : '—'
        case 5:
          return fact ? fact.time_interval : '—'
        case 6:
          let res = ''
          if (!fact) {
            res = '—'
          } else {
            res = this.formatAnswer(fact.icd_code, 2) + ' — ' + this.formatAnswer(fact.diagnosis_text, 2)
            if (res === '— — —') res = '—'
          }
          return res
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
